import { Component , Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { NudgeService } from 'src/app/_shared/providers/nudges/nudge.service';
import { HolidayNudgeData } from 'src/app/app.interfaces';

@Component({
  selector: 'app-holiday-nudge',
  templateUrl: './holiday-nudge.component.html',
  styleUrls: ['./holiday-nudge.component.scss']
})
export class HolidayNudgeComponent {
  totalMessages: number = 0;
  messageSubsription = new Subscription();

  constructor(
    public snackBarRef: MatSnackBarRef<HolidayNudgeComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: HolidayNudgeData,
    private _nudgeService : NudgeService,
  ) 
  {
    this.messageSubsription.add(this._nudgeService.totalMessages.subscribe((data : number) => {
      this.totalMessages = data;
    }));
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
    this.messageSubsription.unsubscribe();
  }
}
